import TextInputLabelHookForm from "./TextInputLabelHookForm";

type Props = {
  day: string;
  groupInfoName: string;
  index: number;
  isAdd: boolean;
  FormMethods: any;
};

export const TimeRangeInput = ({
  day,
  groupInfoName,
  index,
  isAdd,
  FormMethods,
}: Props) => {
  const {
    register,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = FormMethods;

  const startField = `${groupInfoName}.${day}StartTime`;
  const endField = `${groupInfoName}.${day}EndTime`;
  const hoursField = `${groupInfoName}.${day}_hours`;

  const startTime = watch(startField);
  const endTime = watch(endField);

  const updateHoursField = (start: string, end: string) => {
    if (isAdd) {
      const combined = start && end ? `${start}-${end}` : "";
      setValue(hoursField, combined, { shouldDirty: true });
    }
  };

  return (
    <div className="flex items-center w-full justify-between">
      <label className="w-[50%] font-normal text-xs capitalize">{day}</label>
      <div>
        {isAdd && (
          <TextInputLabelHookForm
            className="col-span-3 hidden"
            name={hoursField}
            type="text"
            register={register(hoursField)}
          />
        )}
      </div>
      <div className="w-full flex gap-x-4">
        <div className="w-full">
          <TextInputLabelHookForm
            className={`col-span-3 border ${
              errors?.groupInfos?.[index]?.[`${day}StartTime`]
                ? "border-red-500"
                : ""
            }`}
            name={startField}
            type="time"
            register={register(startField, {
              validate: (value) => {
                const end = getValues(endField);
                const start = value;

                if (start === "Invalid date" && end === "Invalid date")
                  return true;
                if ((start === "Invalid date" || start === "") && end)
                  return "Start time is required";
                if (start && end) {
                  if (start === end)
                    return "Start and end time cannot be the same";
                  if (start > end)
                    return "Start time cannot be later than end time";
                }
                return true;
              },
            })}
            onChange={(e) => {
              const newStartTime = e.target.value;
              setValue(startField, newStartTime, { shouldDirty: true });

              const currentEndTime = getValues(endField);
              updateHoursField(newStartTime, currentEndTime);
            }}
          />
        </div>

        <div className="w-full">
          <TextInputLabelHookForm
            className={`col-span-3 border ${
              errors?.groupInfos?.[index]?.[`${day}EndTime`]
                ? "border-red-500"
                : ""
            }`}
            name={endField}
            type="time"
            register={register(endField, {
              validate: (value) => {
                const start = getValues(startField);
                const end = value;

                if (start === "Invalid date" && end === "Invalid date")
                  return true;
                if ((end === "Invalid date" || end === "") && start)
                  return "End time is required";
                if (start && end) {
                  if (start === end)
                    return "Start and end time cannot be the same";
                  if (start > end)
                    return "Start time cannot be later than end time";
                }
                return true;
              },
            })}
            onChange={(e) => {
              const newEndTime = e.target.value;
              setValue(endField, newEndTime, { shouldDirty: true });

              const currentStartTime = getValues(startField);
              updateHoursField(currentStartTime, newEndTime);
            }}
          />
        </div>
      </div>
    </div>
  );
};
